import { useEffect, useRef } from "react";
/**
 * Adapted from react-beforeunload package.
 * Source: https://github.com/jacobbuck/react-beforeunload
 */
const useBeforeunload = (handler) => {
    const eventListenerRef = useRef();
    useEffect(() => {
        eventListenerRef.current = (event) => {
            const returnValue = handler === null || handler === void 0 ? void 0 : handler(event);
            // Handle legacy `event.returnValue` property
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
            if (typeof returnValue === "string") {
                return (event.returnValue = returnValue);
            }
            // Chrome doesn't support `event.preventDefault()` on `BeforeUnloadEvent`,
            // instead it requires `event.returnValue` to be set
            // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload#browser_compatibility
            if (event.defaultPrevented) {
                return (event.returnValue = "");
            }
        };
    }, [handler]);
    useEffect(() => {
        const eventListener = (event) => { var _a; return (_a = eventListenerRef.current) === null || _a === void 0 ? void 0 : _a.call(eventListenerRef, event); };
        window.addEventListener("beforeunload", eventListener);
        return () => {
            window.removeEventListener("beforeunload", eventListener);
        };
    }, []);
};
export default useBeforeunload;
